module.exports = __webpack_public_path__ + "images/bond-f70474c8e9c34bc2ce4e65009e6cc20a.png";